import React, { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import { accessStorage } from './institutionalConfig.js'
import { getBREDocumentData } from '../common/institutionalServiceHelper.js'
import './institutionalUserAgreement.css'
export default function InstitutionalUserAgreement({ redirectToYourReport }) {
  const [agreementContent, setAgreementContent] = useState('')
  const [isUserAgree, setIsUserAgree] = useState(false)
  const onRadioChange = () => {
    setIsUserAgree(true)
  }

  const onSubmitClick = () => {
    accessStorage.setUserAgreement('agree')
    redirectToYourReport()
  }

  const onCancelClick = () => {
    accessStorage.setUserAgreement(null)
    redirectToYourReport()
  }

  const getBREData = async () => {
    const data = await getBREDocumentData('login/user-agreement')
    setAgreementContent(data[0]?.html?.content)
  }

  useEffect(() => {
    getBREData()
  }, [])

  return (
    <>
      <div className="u-sizeConstrained">
        <div className="u-marginTop10gu u-marginBottom4gu">
          <h2 className="u-paddingBottom2gu u-borderBottom u-inlineBlock u-borderBottomColorBrandLighter">
            Register for online access
          </h2>
        </div>
      </div>
      <div className="u-posRelative u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
        <div className="u-sizeConstrained">
          <div className="Grid">
            <div className="u-sizeFull u-size1of1 u-marginBottom6gu">
              <h2 className="u-marginBottom4gu u-marginTop0">User Agreement</h2>
              <div className="u-border u-padding2gu">
                <div
                  className="agreement-box"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(agreementContent),
                  }}
                ></div>
              </div>
              <div className="Checkbox">
                <input
                  onChange={onRadioChange}
                  className="Checkbox-button class-selection"
                  type="checkbox"
                  id="agreementAccepted"
                  defaultChecked={isUserAgree}
                />
                <label
                  htmlFor="agreementAccepted"
                  className="Checkbox-label u-textSecondary u-cursorPointer"
                >
                  I agree
                </label>
              </div>

              <div className="u-flex">
                <div className="u-flex u-paddingTop4gu">
                  <button
                    onClick={onSubmitClick}
                    disabled={!isUserAgree}
                    className="Button Button--primary  Button--block u-marginRight5gu u-textNoTransform u-flex1of2"
                  >
                    Submit
                  </button>
                  <button
                    onClick={onCancelClick}
                    className="Button Button--tertiary Button--block u-textNoTransform u-flex1of2"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
